import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ACHBankForm from ".";
import { translate } from "../../helper";

export const ACHBankAccountModal = ({ open, onClose, onLinked }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [startLinkFlow, setStartLinkFlow] = useState(false);

  const begin = (e) => {
    e.preventDefault();
    if (!email) return;
    setStartLinkFlow(true);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      centered
      PaperProps={{
        sx: {
          borderRadius: "calc(var(--sp-md2)*1.509434) !important" ,
          overflow: "hidden",
          maxWidth: "calc(var(--fs-hero)*14.1509434)"
        },
      }}
    >
      <Box
        sx={{
          px: "calc(var(--sp-lg)*1.132075)",
          py: "calc(var(--sp-md2)*1.509434)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #eee",
          background: "linear-gradient(135deg, #fafafa, #ffffff)",
        }}
      >
        <Typography variant="h6" fontWeight={600} fontSize={'calc(var(--fs-xs)*1.88679)'}>
          {translate("connectBankAccount") || "Link Bank Account (ACH)"}
        </Typography>

        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{fontSize: 'calc(var(--fs-xs)*1.88679)'}}/>
        </IconButton>
      </Box>

      <DialogContent sx={{ mt: 'calc(var(--sp-md2)*1.509434)' }}>
        {!startLinkFlow && (
          <Box
            component="form"
            onSubmit={begin}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "calc(var(--sp-lg)*1.132075)",
              p: "calc(var(--sp-xxs)*2)",
            }}
          >
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 'calc(var(--sp-xxs)*2)', color: "text.secondary", fontSize:'calc(var(--fs-xs)*1.32075)' }}>
                Step 1 of 2
              </Typography>
              <Typography variant="h6" fontWeight={600} fontSize={'calc(var(--fs-xs)*1.88679)'}>
                Enter your basic details
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 'calc(var(--sp-xxs)*2)', fontSize:'calc(var(--fs-xs)*1.32075)' }}>
                We’ll use this information to verify and link your bank account securely.
              </Typography>
            </Box>

            <Divider/>

            <TextField
              placeholder={translate("fullName") || "Full Name"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              fullWidth
              variant="outlined"
              InputProps={{ sx: { borderRadius: 'calc(var(--sp-md2)*1.132075)' } }}
            />

            <TextField
              placeholder={translate("email") || "Email"}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              variant="outlined"
              InputProps={{ sx: { borderRadius: 'calc(var(--sp-md2)*1.132075)' } }}
              FormHelperTextProps={{
                sx: {
                  fontSize: 'calc(var(--fs-xs)*1.132075)',
                  marginTop: 'calc(var(--sp-xxs)*1.132075)',
                  color: '#6B7280',
                },
              }}
              helperText="We'll send verification updates to this email"
            />

            <DialogActions sx={{ px: 0, mt: 'calc(var(--sp-xxs)*2)', gap: 'calc(var(--sp-md2)*1.132075)' }}>
              <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 'calc(var(--sp-lg)*1.132075)',px: 'calc(var(--sp-lg)*1.509434)',
                  py: 'calc(var(--sp-xs)*1.81132075)',fontSize: 'calc(var(--fs-xs)*1.32075)' }}>
                {translate("cancel") || "Cancel"}
              </Button>

              <Button
                type="submit"
                variant="contained"
                disabled={!email}
                sx={{
                  borderRadius: 'calc(var(--sp-lg)*1.132075)',
                  px: 'calc(var(--sp-lg)*1.509434)',
                  py: 'calc(var(--sp-xs)*1.81132075)',
                  fontSize: 'calc(var(--fs-xs)*1.32075)',
                }}
              >
                {translate("continue") || "Continue"}
              </Button>
            </DialogActions>
          </Box>
        )}

        {startLinkFlow && (
          <ACHBankForm
            customerEmail={email}
            customerName={name}
            goBack={onClose}
            onLinked={(info) => {
              onLinked?.(info);
              onClose();
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
